export default __webpack_public_path__ + "static/media/ee.0e9618e8.svg";